module.exports = __webpack_public_path__ + "static/media/ic_arrow.fa7bb72a.svg";